var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarsSpan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60.998 94.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1",
    x: 0,
    y: 53.737,
    width: 40.502,
    height: 40.502,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2",
    x: 7.274,
    y: 0,
    width: 37.5,
    height: 37.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_3",
    x: 22.502,
    y: 16.969,
    width: 38.496,
    height: 48.408,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text_Graphic_Span",
    "data-name": "Text Graphic Span",
    transform: "translate(429.803 251.114)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -429.8, -251.11)",
    filter: "url(#Path_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M-409.552-186.363l3.977-7.272,7.274-3.979-7.274-3.977-3.977-7.274-3.977,7.274-7.274,3.977,7.274,3.979Z",
    transform: "translate(429.8 268.6)",
    fill: "#0a67b2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -429.8, -251.11)",
    filter: "url(#Path_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M-406.147-225.614l2.582-7.167,7.169-2.584-7.169-2.582-2.582-7.167-2.582,7.167-7.167,2.582,7.167,2.584Z",
    transform: "translate(432.17 251.11)",
    fill: "#22a9e1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -429.8, -251.11)",
    filter: "url(#Path_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M-420.5-206.26l4.027-11.175,6.221-4.027-6.221-4.029-4.027-11.176-4.027,11.176-6.221,4.029,6.221,4.027Z",
    transform: "translate(462.25 259.64)",
    fill: "#e95f5c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsSpan);
export default __webpack_public_path__ + "static/media/stars-span.a5a3090c.svg";
export { ForwardRef as ReactComponent };